var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"news-time"},[_vm._v(_vm._s(_vm.info.createtime))]),_c('div',{staticClass:"news-content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }